import {
  setWorkstationPong,
  addPongHistoryEntry
} from "~/features/andon/andon.slice";

import { PongData } from "~/features/andon/andon.types";
import { hubs } from "~/lib/signalr";
import { HeartbeatEvent } from "~/types/api";

import { collectPongData } from "./heartbeat.logic";

// when recieving a ping, respond with a pong with collected pongData
export async function handleHeartbeatPing({
  data,
  siteWorkstationId,
  extendPongData
}: {
  data: HeartbeatEvent.Ping;
  siteWorkstationId: string;
  extendPongData: boolean;
}) {
  const { targetWorkstationId, timePingSent } = data.item;
  // If this ping is for another workstation, ignore
  if (siteWorkstationId !== targetWorkstationId && targetWorkstationId !== "") {
    return;
  }

  const pongData: PongData = await collectPongData({ extendPongData });
  const pongEvent: HeartbeatEvent.Pong = {
    case: "Pong",
    item: {
      connection: pongData,
      sourceWorkstationId: siteWorkstationId,
      timePingSent: timePingSent // echo the original ping time
    }
  };
  hubs.send.next(pongEvent);
}

// when receiving a pong, update the workstation with the pong data
export function handleHeartbeatPong({
  data,
  dispatch
}: {
  data: HeartbeatEvent.Pong;
  dispatch: (action: unknown) => void;
}) {
  const now = new Date();
  const sentTime = new Date(data.item.timePingSent);
  const pongLoopTime = now.getTime() - sentTime.getTime();

  const rawPongData = data.item.connection as Partial<PongData> | undefined;

  if (!rawPongData) return;

  const pongData: PongData = { ...rawPongData };

  dispatch(
    setWorkstationPong({
      workstationId: data.item.sourceWorkstationId,
      pongData,
      pongLoopTime
    })
  );

  dispatch(
    addPongHistoryEntry({
      workstationId: data.item.sourceWorkstationId,
      pongData,
      loopTime: pongLoopTime
    })
  );
}
